import { FC, ReactNode } from 'react';
import styles from './SubscriptionHeader.module.scss';

type Props = {
  title: string;
  children: ReactNode;
};

const SubscriptionHeader: FC<Props> = ({ title, children }) => {
  return (
    <div className={styles.bns3_SubscriptionHeader}>
      <div className={styles.headerContainer}>
        <div className={styles.bns3_subscriptionsTitle}>{title}</div>
        <div className={styles.bns3_subscriptionsAction}>{children}</div>
      </div>
    </div>
  );
};

export default SubscriptionHeader;
